import { Observable, throwError } from 'rxjs';

import { ErrorHandlerService } from '../shared/error-handler.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StaticPageInterface } from '@app/interfaces/static-page.interface';
import { WordpressPaging } from '@app/enums/_index';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementService extends ErrorHandlerService {
  private announcementURL = `${environment.cms.url}/wp-json/wp/v2/certifyannouncement`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns all the information related to Announcements
   * @returns Announcement content Observable
   */
  getAnnouncementContent(): Observable<StaticPageInterface[]> {
    const announcementContentParams = getCacheBustedParams();
    return this.http.get(`${this.announcementURL}`, { params: announcementContentParams }).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(
        this.handleError<StaticPageInterface[]>('getCertificationContent Announcements', [])
      )
    );
  }

  /**
   * Returns all the information related to Announcements
   * @returns Announcement content Observable
   */
  getAnnouncementContentBySlug(slug: string): Observable<StaticPageInterface[]> {
    const announcementContentSlugParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);
    return this.http
      .get(`${this.announcementURL}?slug=${slug}`, { params: announcementContentSlugParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(
          this.handleError<StaticPageInterface[]>('getAnnouncementContentBySlug Announcements', [])
        )
      );
  }
}
